import { render, staticRenderFns } from "./UberIcon.vue?vue&type=template&id=38592b5c&scoped=true"
import script from "./UberIcon.vue?vue&type=script&lang=js"
export * from "./UberIcon.vue?vue&type=script&lang=js"
import style0 from "./UberIcon.vue?vue&type=style&index=0&id=38592b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38592b5c",
  null
  
)

export default component.exports